import OfficeLocation from "./website/contact-components/OfficeLocation";
import SendMessageForm from "./website/contact-components/SendMessageForm";
import ContactHeader from "./website/contact-components/ContactHeader";

export default function ContactUs() {
    return(
        <>
        <ContactHeader />
        <SendMessageForm />
        <OfficeLocation />
        </>
    )}